import React, { useState } from 'react'
import { Link } from "react-router-dom"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import redirections from "../img/redirections.svg";
import CustomDropdown from "../Components/CustomDropdown";
import RedirectionsTable from "../Components/Datatables/RedirectionsTable";


function Redirections() {

    const [selected, setSelected] = useState({
        option: "Aktív",
        key: "active",
    });
    const [isActive, setIsActive] = useState(false);

    const selectedOptions = [{ option: 'Mind', key: 'all' }, { option: 'Aktív', key: 'active' }, { option: 'Inaktív', key: 'inactive' }];

    return (
        <div className="page-content">

            <div className={isActive ? 'content-blur' : ""}></div>

            <div>
                <Row>
                    <Col xs lg="2" className="page-title"><img src={redirections} alt="redirection icon" /><h1>Átirányítások</h1></Col>
                    <Col className='right-content'>
                        <Link to="/newredirection" >
                            <button className="custom-button"><span className="plus">+</span>Új Átirányítás</button>
                        </Link>
                        <CustomDropdown selected={selected} setSelected={setSelected} options={selectedOptions} isActive={isActive} setIsActive={setIsActive} className={"dropdown"} />
                    </Col>
                </Row>
            </div>
            <RedirectionsTable selected={selected} />
        </div>
    )

}

export default Redirections;